export const common = {
  // Navigation
  home: 'Home',
  about: 'About',
  services: 'Services',
  contact: 'Contact',
  
  // Common actions
  submit: 'Submit',
  cancel: 'Cancel',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  
  // Status messages
  loading: 'Loading...',
  success: 'Success',
  error: 'Error',
  
  // Healthcare specific
  patient: 'Patient',
  caregiver: 'Caregiver',
  appointment: 'Appointment',
  referral: 'Referral'
};

export default common;